export type SellerGroup = {
  id: string;
  name: string;
  profile: string;
};

export type ProfileChange = {
  groupId: string;
  groupName: string;
  oldProfile: string;
  newProfile: string;
};

export type HistoryEntry = {
  id: string;
  date: string;
  user: string;
  changes: ProfileChange[];
};

export const PROFILE_OPTIONS = [
  '',
  'Compra Agora',
  'Indústria',
  'Seller',
] as const;

export type ImportChangeType = 'new' | 'changed' | 'unchanged';

export type ImportRow = {
  groupId: string;
  groupName: string;
  profile: string;
  valid: boolean;
  reason?: string;
  changeType?: ImportChangeType;
  currentProfile?: string;
};
